import camelize from "camelize-ts";
import { DefaultService } from "../generated";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toaster } from "../components/toaster";
import { useNavigate } from "react-router-dom";

export const useInvoiceDetail = (invoiceNumber: string) => {
  return useQuery({
    queryKey: ["invoiceDetail", invoiceNumber],
    queryFn: () =>
      DefaultService.fakturInvoicesViewsInvoiceDetail({
        invoiceStr: invoiceNumber,
      }),
    select: (data) => camelize(data),
  });
};

export const useInvoiceDelete = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationKey: ["invoiceDelete"],
    mutationFn: ({ invoiceUuid }: { invoiceUuid: string }) => {
      return DefaultService.fakturInvoicesViewsInvoiceDelete({
        invoiceStr: invoiceUuid,
      });
    },
    onSuccess: () => {
      toaster.success({ title: "Faktura slettet!" });
      queryClient.invalidateQueries({ queryKey: ["invoiceDetail"] });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
      navigate("/invoices/");
    },
  });
};
